<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :search-input.sync="search"
    :items="items"
    item-text="name"
    item-value="id"
    :loading="loading"
    clearable
    v-bind="$attrs"
  )

</template>

<script>
import api from '../api';
import { isVcht } from '@/constants/global';

export default {
  props: {
    value: { type: [Object, Number], default: null },
    projectId: { type: [Number], required: true },
  },
  data: () => ({
    model: null,
    search: null,
    items: [],
    loading: false,

    roleId: null,
    isVcht,
  }),
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    search() {
      if (this.loading) return;
      if (this.inputValue) return;
      this.loading = true;

      this.fetchItems();
    },
  },
  async created() {
    await this.fetchRoleId();
    this.fetchItems();
  },
  methods: {
    fetchRoleId() {
      const [userRole] = this.$user.roles;
      const params = {
        'search[project_id]': this.projectId,
        'search[name]': userRole.name,
        'per-page': 100,
      };

      return this.$rHandler(
        api.fetchProjectRoles(params),
        ({ data }) => {
          const [role] = data.data.filter((item) => item.project_id === this.projectId);
          this.roleId = role?.id;
        },
      );
    },
    fetchItems() {
      const params = {
        'search[name]': this.search,
        'search[project_role_id]': `${this.isVcht ? 34 : 20},${this.roleId ? this.roleId : ''},`,
        expand: 'has_child',
      };
      this.$rHandler(
        api.fetchQuestionCategories(params),
        ({ data }) => {
          this.items = data.data;
        },
      ).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
